import { render, staticRenderFns } from "./tjrc1.vue?vue&type=template&id=603fe6c2&scoped=true&"
import script from "./tjrc1.vue?vue&type=script&lang=js&"
export * from "./tjrc1.vue?vue&type=script&lang=js&"
import style0 from "./tjrc1.vue?vue&type=style&index=0&id=603fe6c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603fe6c2",
  null
  
)

export default component.exports